import React, { Component } from "react";

export default class SellerCard extends Component {
  render() {
    return (
      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12 card-3D">
        <div className="relative">
          {this.props.seller.seller.map_url && (
            <div className="location-shopping">
              <a
                href={this.props.seller.seller.map_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  version="1.1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 60 60"
                  enableBackground="new 0 0 60 60"
                >
                  <g>
                    <path
                      d="M30,26c3.86,0,7-3.141,7-7s-3.14-7-7-7s-7,3.141-7,7S26.14,26,30,26z M30,14c2.757,0,5,2.243,5,5s-2.243,5-5,5
                                                s-5-2.243-5-5S27.243,14,30,14z"
                    />
                    <path
                      d="M29.823,54.757L45.164,32.6c5.754-7.671,4.922-20.28-1.781-26.982C39.761,1.995,34.945,0,29.823,0
                                                s-9.938,1.995-13.56,5.617c-6.703,6.702-7.535,19.311-1.804,26.952L29.823,54.757z M17.677,7.031C20.922,3.787,25.235,2,29.823,2
                                                s8.901,1.787,12.146,5.031c6.05,6.049,6.795,17.437,1.573,24.399L29.823,51.243L16.082,31.4
                                                C10.882,24.468,11.628,13.08,17.677,7.031z"
                    />
                    <path
                      d="M42.117,43.007c-0.55-0.067-1.046,0.327-1.11,0.876s0.328,1.046,0.876,1.11C52.399,46.231,58,49.567,58,51.5
                                                c0,2.714-10.652,6.5-28,6.5S2,54.214,2,51.5c0-1.933,5.601-5.269,16.117-6.507c0.548-0.064,0.94-0.562,0.876-1.11
                                                c-0.065-0.549-0.561-0.945-1.11-0.876C7.354,44.247,0,47.739,0,51.5C0,55.724,10.305,60,30,60s30-4.276,30-8.5
                                                C60,47.739,52.646,44.247,42.117,43.007z"
                    />
                  </g>
                </svg>
              </a>
            </div>
          )}
          <div className="insurance-icon">
            <svg
              viewBox="0 0 59 70"
              version="1.1"
              style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
              }}
            >
              <g transform="matrix(1,0,0,1,-7881.75,-6625.34)">
                <g transform="matrix(1,0,0,0.87168,238.526,5727.35)">
                  <g transform="matrix(0,5.81647,5.0701,0,742.511,-3256.67)">
                    <path
                      d="M737.218,1366.8L738.113,1366.8"
                      style={{
                        fill: "none",
                        fillRule: "nonzero",
                        stroke: "white",
                        strokeWidth: "0.39px",
                      }}
                    />
                  </g>
                  <g transform="matrix(5.0701,0,0,5.81647,3932.29,-6882.18)">
                    <path
                      d="M733.516,1365.41C734.125,1365.41 734.641,1365.81 734.83,1366.35L734.984,1366.35C735.173,1365.81 735.689,1365.41 736.298,1365.41C736.908,1365.41 
                                            737.424,1365.81 737.613,1366.35L737.714,1366.35C737.902,1365.81 738.418,1365.41 739.028,1365.41C739.637,1365.41 740.153,1365.81 
                                            740.342,1366.35L740.496,1366.35C740.685,1365.81 741.202,1365.41 741.81,1365.41C742.42,1365.41 742.936,1365.81 743.124,1366.35L743.233,1366.35C743.233,1363.63 
                                            740.747,1361.43 737.679,1361.43C734.611,1361.43 732.124,1363.63 732.124,1366.35L732.202,1366.35C732.39,1365.81 732.906,1365.41 
                                            733.516,1365.41Z"
                      style={{
                        fill: "none",
                        fillRule: "nonzero",
                        stroke: "white",
                        strokeWidth: "0.39px",
                      }}
                    />
                  </g>
                  <g transform="matrix(0.898922,0,0,1.03125,-102.885,-4331.47)">
                    <path
                      d="M8629.86,5236.27C8630.61,5236.67 8631.28,5237.19 8631.86,5237.8L8631.86,5275L8667.24,5275L8667.24,5237.84C8667.82,5237.22 8668.49,5236.7 
                                            8669.24,5236.29L8669.24,5275.93C8669.16,5277.07 8668.02,5276.96 8668.02,5276.96C8667.89,5276.99 8667.89,5276.99 8667.74,5277L8630.86,5277C8630.09,5276.95 
                                            8629.92,5276.74 8629.86,5276L8629.86,5236.27ZM8640.42,5235.49L8638.72,5237.51L8638.72,5258.49L8646.81,5268.15L8652.24,5268.15L8660.38,5258.42L8660.38,5237.47L8658.72,5235.49C8660.11,5235.75 8661.36,5236.37 
                                            8662.38,5237.26L8662.38,5269.15C8662.33,5269.92 8662.11,5270.09 8661.38,5270.15L8646.34,5270.15L8646.34,5270.15L8637.76,5270.15L8637.76,5270.15L8637.72,5270.15C8636.95,5270.09 
                                            8636.77,5269.88 8636.72,5269.15L8636.72,5237.28C8637.75,5236.38 8639.02,5235.75 8640.42,5235.49ZM8638.76,5268.15L8644.2,5268.15L8638.76,5261.65L8638.76,5268.15ZM8654.89,5268.09L8660.33,5268.09L8660.33,5261.59C8658.52,5263.76 
                                            8656.71,5265.92 8654.89,5268.09ZM8645.88,5236.45C8646.46,5236.8 8647,5237.22 8647.47,5237.71L8641.74,5247.97L8649.55,5261.97L8657.36,5247.97L8651.65,5237.73C8652.12,5237.24 8652.65,5236.82 8653.23,5236.47L8659.38,5247.49C8659.61,5247.96 
                                            8659.59,5248.02 8659.38,5248.46L8650.42,5264.51C8650.02,5265.14 8649.08,5265.15 8648.68,5264.51L8639.73,5248.46C8639.5,5247.99 8639.51,5247.93 8639.73,5247.49L8645.88,5236.45Z"
                      style={{ fill: "white" }}
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          {this.props.seller.on_sale && (
            <div className="sales">
              <strong>{this.props.texts["onSale"]}</strong>
            </div>
          )}
          <img
            className="w-100"
            src={
              this.props.seller.seller.logo
                ? this.props.seller.seller.logo
                : "/static/img/273.png"
            }
            target="_blank"
            rel="noopener noreferrer"
            alt="Seller Logo"
          />
        </div>
        <div className="texts-body">
          <div className="w-100 d-flex size-carpet">
            <p className="m-0">{this.props.texts["availableRugSizes"]} </p>
            <span className="">{this.props.seller.available_sizes}</span>
          </div>
          <a
            href={
              this.props.seller.seller.buy_url
                ? this.props.seller.seller.buy_url
                : this.props.seller.seller.map_url
            }
          >
            <h4 className="text-center" style={{ color: "black" }}>
              {this.props.seller.seller.name}
            </h4>
          </a>
          <p className="text-center">
            <strong>{this.props.texts["phoneNumber"]}:</strong>{" "}
            {this.props.seller.seller.phone
              ? this.props.seller.seller.phone
              : "-"}
            <br />
            <strong>{this.props.texts["address"]}:</strong>{" "}
            {this.props.seller.seller.address
              ? this.props.seller.seller.address
              : "-"}
          </p>

          <a
            href={this.props.seller.buy_url ? this.props.seller.buy_url : "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            {/* 
				TODO: 
			  		- Replace CSS class with inline css. 
					- Change background color based on disabled state (In CSS).
			*/}
            <button
              disabled={!this.props.seller.buy_url}
              style={{
                display: "flex",
                height: "40px",
                width: "90%",
                borderRadius: "5px",
                marginBottom: "10px",
                backgroundColor: this.props.seller.buy_url
                  ? "#de2a35"
                  : "rgba(139, 140, 142,0.3)",
                color: "#fff",
                position: "absolute",
                bottom: 0,
                left: 12,
                justifyContent: "center",
                alignItems: "center",
                cursor: this.props.seller.buy_url ? "pointer" : "",
                fontSize: "15px",
                fontWeight: 700,
              }}
            >
              خرید
            </button>
          </a>
        </div>
      </div>
    );
  }
}
